const LIC_EXP_DATE_UTC_EN_US = {
  timeZone: 'UTC',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};

/** Device list credit expiration: UTC calendar date, long month (matches device grid columns). */
export function formatDeviceLicExpDate(licExpDate) {
  if (licExpDate == 0) return 'N/A';
  return new Date(licExpDate).toLocaleDateString('en-US', LIC_EXP_DATE_UTC_EN_US);
}

/**
 * Formats an epoch value (accepts seconds or milliseconds, or a parseable date string)
 * as a locale time string, optionally in a given IANA timezone (e.g. an alarm's own nasCode).
 */
export const toLocalTime = (epoch, timezone) => {
  if (epoch === undefined || epoch === null || epoch === '') return '-';
  const numeric = Number(epoch);
  let date;
  if (Number.isFinite(numeric)) {
    // Numeric input must be a positive epoch to be meaningful. Don't fall through to
    // Date.parse for 0/negative numerics - it coerces them to strings and can return an
    // implementation-dependent, silently-wrong date (e.g. Date.parse(0) → "1/1/2000" in V8)
    // instead of the "-" we want for invalid input.
    if (numeric <= 0) return '-';
    const ms = numeric >= 1e12 ? numeric : numeric * 1000;
    date = new Date(ms);
  } else {
    // Non-numeric input: may be a genuine parseable date string (e.g. an ISO timestamp).
    const parsed = Date.parse(epoch);
    date = Number.isNaN(parsed) ? null : new Date(parsed);
  }
  if (!date || Number.isNaN(date.getTime())) return '-';
  if (!timezone) return date.toLocaleString();
  try {
    return date.toLocaleString(undefined, { timeZone: timezone });
  } catch {
    return date.toLocaleString();
  }
};
